module.exports = __webpack_public_path__ + "ticket_icon-0948e14d4ee64c398deec409b6282897.svg";